import React, { ChangeEvent, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { LABELS, LTS_ROUTES_PATH } from '../../constants/LTSConstants';
import HTMLHead from '../../components/HTMLHead/HTMLHead.component';
import HeaderSearch from './components/HeaderSearch/HeaderSearch.component';
import '../../../../styles/LTSTrainNumber.css';
import { AutoSuggestTrainsList } from './components/AutoSuggestTrainsList/AutoSuggestTrainsList';

const LTSTrainNumber = (props) => {
  // ---------- props ----------
  const { data } = props;

  // ---------- hooks ----------
  const history = useHistory();

  // ---------- state ----------
  const [query, setQuery] = useState('');

  // ---------- functions ----------
  const showTrainList = (query: string) => {
    setQuery(query);
  };

  const clearText = () => {
    setQuery('');
  };

  const handleOnInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    showTrainList(e.target.value);
  };

  const handleOnTrainSelected = () => {
    //redirect to LTS landing
    history.push(LTS_ROUTES_PATH.landingPage);
  };

  // ---------- jsx ----------
  return (
    <Fragment>
      <HTMLHead data={data} blockSearchEngineIndexing />
      <HeaderSearch
        placeholder={LABELS.TRAIN_SEARCH_INPUT_PLACEHOLDER}
        value={query}
        buttonLabel={LABELS.CLEAR_BUTTON_LABEL}
        onChange={handleOnInputChange}
        onButtonClick={clearText}
      />
      <main className="LTSTrainNumber-main-wrapper">
        <AutoSuggestTrainsList searchQuery={query} handleOnTrainSelected={handleOnTrainSelected} />
      </main>
    </Fragment>
  );
};

LTSTrainNumber.propTypes = {
  data: PropTypes.object
};

export default LTSTrainNumber;
